function getProductJsonLd() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var productSchema = null;

    Array.prototype.some.call(scripts, function(script) {
        try {
            var data = JSON.parse(script.textContent);

            if (data && data["@type"] === "Product" && data.name) {
                productSchema = data;
                return true;
            }
        } catch (e) {
            return false;
        }

        return false;
    });

    return productSchema;
}

function addProductTypeToBvSummaryJsonLd() {
    var script = document.getElementById("bv-jsonld-bvloader-summary");

    if (!script || !script.textContent || script.textContent.indexOf("\"aggregateRating\"") === -1) {
        return;
    }

    try {
        var data = JSON.parse(script.textContent);

        if (!data.aggregateRating) {
            return;
        }

        var productSchema = getProductJsonLd() || {};
        var needsType = data["@type"] !== "Product";
        var needsName = !data.name;
        var needsOffers = !data.offers && productSchema.offers;

        if (!needsType && !needsName && !needsOffers) {
            return;
        }

        var normalizedData = {
            "@context": data["@context"],
            "@type": "Product",
            name: data.name || productSchema.name
        };

        Object.keys(data).forEach(function(key) {
            if (key !== "@context" && key !== "@type") {
                normalizedData[key] = data[key];
            }
        });

        if (!normalizedData.name) {
            normalizedData.name = document.querySelector(".product-name") ? document.querySelector(".product-name").textContent.trim() : document.title;
        }

        if (!normalizedData.offers && productSchema.offers) {
            normalizedData.offers = productSchema.offers;
        }

        script.textContent = JSON.stringify(normalizedData, null, 2);
    } catch (e) {
        // Ignore invalid or incomplete JSON-LD while Bazaarvoice is still rendering.
    }
}

function watchBvSummaryJsonLd() {
    addProductTypeToBvSummaryJsonLd();

    if (typeof MutationObserver === "undefined") {
        return;
    }

    var observer = new MutationObserver(function() {
        addProductTypeToBvSummaryJsonLd();
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
    });
}

$(document).ready(function() {
    window.bvCallback = function(BV) {
        if (typeof BV !== "undefined" && typeof BV.reviews !== "undefined") {
            BV.reviews.on("show", function() {
                // This line assumes SFRA collapsible panels and is called when clicking on the review summary
                $(".row.reviews:not(.active)").toggleClass("active");
                addProductTypeToBvSummaryJsonLd();
            });
            if (typeof BV.questions !== "undefined") {
                BV.questions.on("show", function() {
                    // This line assumes SFRA collapsible panels and is called when clicking on the Q&A summary
                    $(".row.questions:not(.active)").toggleClass("active");
                });
            }
        }
    };
    watchBvSummaryJsonLd();
    setTimeout(function() {
        $("[id='data-bv-show']").css("display", "block");
        addProductTypeToBvSummaryJsonLd();
    }, 1500);
});
